import { type ApiResponse, ApiFactory } from '@/utils/api'
import type {
  GetOperationChartReqType,
  GetClawOperationsInfoReqType,
  GetCoinOperationsInfoReqType,
  UpdateMachineActionReqType,
  CoinRetrievalActionReqType
} from '@/models/types/dashboard.types'
import { DashboardEnum } from '@/constants/enums/api/dashboard.enums'

export class DashboardServices extends ApiFactory {
  constructor() {
    super('')
  }

  /** 取得店家選物機圖表 */
  getOperationClawChart = async (
    params: GetOperationChartReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetOperationChartReqType, ApiResponse>(
      DashboardEnum.operationsClawChart,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得店家選物機圖表 */
  getOperationClawChartV2 = async (
    params: GetOperationChartReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetOperationChartReqType, ApiResponse>(
      DashboardEnum.operationsClawChartV2,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得店家兌幣機圖表 */
  getOperationCoinChart = async (
    params: GetOperationChartReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetOperationChartReqType, ApiResponse>(
      DashboardEnum.operationsCoinChart,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得店家兌幣機圖表 */
  getOperationCoinChartV2 = async (
    params: GetOperationChartReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetOperationChartReqType, ApiResponse>(
      DashboardEnum.operationsCoinChartV2,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得店家選物機運營清單 */
  getClawOperationsInfo = async (
    params: GetClawOperationsInfoReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetClawOperationsInfoReqType, ApiResponse>(
      DashboardEnum.clawOperationsInfo,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得店家選物機運營清單 */
  getClawOperationsInfoV2 = async (
    params: GetClawOperationsInfoReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<GetClawOperationsInfoReqType, ApiResponse>(
      DashboardEnum.clawOperationsInfoV2,
      params,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得店家兌幣機運營清單 */
  getCoinOperationsInfo = async (
    params: GetCoinOperationsInfoReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DashboardEnum.coinOperationsInfo, params, {
      signal: abortSignal
    })
  }

  /** 新系統：取得店家兌幣機運營清單 */
  getCoinOperationsInfoV2 = async (
    params: GetCoinOperationsInfoReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DashboardEnum.coinOperationsInfoV2, params, {
      signal: abortSignal
    })
  }

  /** 機台操作 */
  updateMachineAction = async (params: UpdateMachineActionReqType[]): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(DashboardEnum.machineAction, params)
  }

  /** 清除特定機器所有帳目功能 */
  deleteMachineAccount = async (params: { pcbId: string }): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(DashboardEnum.machineDelAccount, params)
  }

  /** 選物機錢箱收款 */
  coinRetrievalAction = async (params: CoinRetrievalActionReqType[]): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(DashboardEnum.coinRetrievalAction, params)
  }

  /** 新系統：選物機錢箱收款（請求格式與 V1 相同） */
  coinRetrievalActionV2 = async (params: CoinRetrievalActionReqType[]): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(DashboardEnum.coinRetrievalActionV2, params)
  }
}
